import axios from "axios";
const BASE_URL = process.env.VUE_APP_API_URL;

axios.defaults.baseURL = BASE_URL;

axios.interceptors.request.use(
  () => {
    throw new axios.Cancel("service-terminated");
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axios;
